/* eslint-disable max-len */
import { ofType, StateObservable } from 'redux-observable';
import {
  catchError, debounceTime, filter, from, map, mergeMap, Observable, of, switchMap, takeUntil,
} from 'rxjs';
import { AxiosError } from 'axios';
import { showErrorToaster, showSuccessToaster } from '../../../../../Common/ComponentToast/ComponentSuccessToasts';
import Config from '../../../../../Common/Config';
import {
  makeDeleteRequest, makeGetRequest,
  makeGetRequestWithParams,
  makePostRequest, makePutRequest,
} from '../../../../../Common/NetworkOps';
import {
  addJobReport,
  addJobReportFailure,
  addJobReportSuccess,
  deleteReportByIdFailure,
  deleteReportByIdStart,
  deleteReportByIdSuccess,
  deleteScheduleByIdFailure,
  deleteScheduleByIdStart,
  deleteScheduleByIdSuccess,
  getAssociatedVesselsFailure,
  getAssociatedVesselsStart,
  getAssociatedVesselsSuccess,
  getCommentData,
  getForecastReport,
  getForecastReportFailure,
  getForecastReportSuccess,
  getGeneralVesselsFailure,
  getGeneralVesselsStart,
  getGeneralVesselsSuccess,
  getHotelList,
  getJobScheduleListData, getJobScheduleListDataFailure,
  getJobScheduleListDataSuccess, getJobScheduleUnitData, getJobScheduleUnitDataFailure,
  getJobScheduleUnitDataSuccess, getJobTravelListData,
  getJobTravelListDataFailure, getJobTravelListDataSuccess,
  getReportByIdFailure,
  getReportByIdStart,
  getReportByIdSuccess,
  getSchedulingPdfData,
  getSchedulingPdfDataFailure,
  getSchedulingPdfDataSuccess,
  getTravelDataById,
  gotCommentData,
  gotHotelList,
  gotTravelDataById,
  JobScheduleActions, onAddAccommodationSchedule,
  onAddAccommodationScheduleFailure, onAddAccommodationScheduleSuccess,
  onAddSchedule, onAddScheduleFailure, onAddScheduleSuccess,
  onCreateJobSchedule,
  onCreateJobScheduleSuccess,
  onDeleteAccommodationSchedule, onReadyToSendFailure, onReadyToSendStart, onReadyToSendSuccess, onUpdateAccommodationSchedule,
  onUpdateSchedule,
  onUpdateSiteData,
  onUpdateSiteDateFailure,
  onUpdateSiteDateSuccess,
  // setSelectedTab,
  travelDataByIdFailure,
} from './jobScheduleSlice';
import {
  AddHotelPayload,
  AddJobScheduleWholePayload,
  AddJobScheduleWholeResponse,
  AddSchedulePayload,
  AddScheduleResponse,
  CommentTabDataResponse,
  EditSchedulePayload,
  JobScheduleListDataResponse, JobScheduleListPayload,
  JobTravelListDataResponse,
  PayloadJobForm,
  UpdateSitePayload,
  UpdateSitePayloadData,
  UpdateSiteResponse,
  TravelDataById,
  ReadyToSendStartAPiResponse,
  CheckedReadyToSendInterface,
} from '../../utils/types';
// import EndPoints from '../../../../../Routes/EndPoints';
import { TravelDefaultData } from '../utils/constants';
import { RootState } from '../../../../../redux/rootState';
import { Empty } from '../../../../ScreenAddSmc/Utils/TypeSmc';
import { createFetchDataEpic, createGetEpicWithData, getData } from '../../../../../utils/CommonEpic';
import {
  AllVesselsListingDetails, GetAssociatedVesselsPayload, GetGeneralVesselsPayload, VesselsListingDetails,
} from '../utils/types';
import {
  AddReportPayload, DeleteSchedulePayload, DeleteVesselReportPayload, SetVesselData,
} from '../components/AddReportModal/utils/Type';
import { DeleteReportApiResponse, GetForecastDataApiResponse, GetSchedulePdfDataApiResponse } from '../components/ReportListingModal/Type';
import { setLoader } from '../../../../../redux/loaderSlice';
import { updateSite } from '../../../../Job/jobStarter/addJob/redux/addJobSlice';

let lastScheduleApiController: AbortController | null = null;
async function getJobScheduleSites(data: JobScheduleListPayload): Promise<JobScheduleListDataResponse> {
  if (lastScheduleApiController) lastScheduleApiController.abort(); // ← cancel previous API
  lastScheduleApiController = new AbortController();

  const url = `${Config.jobsSchedule.JobSchedulinglist}?Type=${data?.type}&pageNumber=${data.page}&pageSize=${data.rowsPerPage}&searchItem=${data.searchQuery}`;
  const result = await makeGetRequest<JobScheduleListDataResponse>(url, { signal: lastScheduleApiController.signal });
  return result.data;
}

export const getJobScheduleListDataEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(getJobScheduleListData.type),
  map((x) => x.payload),
  debounceTime(1000),
  switchMap((data: JobScheduleListPayload) => from(getJobScheduleSites(data)).pipe(
    map((res: JobScheduleListDataResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getJobScheduleListDataSuccess(res.BMT.Result);
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return getJobScheduleListDataFailure();
    }),
    takeUntil(action$.pipe(filter(getJobScheduleListData.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getJobScheduleListDataFailure(error));
    }),
  )),
);

async function getJobScheduleUnit(data: JobScheduleListPayload): Promise<JobScheduleListDataResponse> {
  // eslint-disable-next-line max-len
  const url = `${Config.jobsSchedule.SchedulingUnitList}?pageNumber=${data.page}&pageSize=${data.rowsPerPage}&searchItem=${data.searchQuery}&BidId=${data.BidId}`;
  const result = await makeGetRequest<JobScheduleListDataResponse>(url);
  return result.data;
}

export const getJobScheduleUnitDataEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(getJobScheduleUnitData.type),
  map((x) => x.payload),
  debounceTime(250),
  mergeMap((data: JobScheduleListPayload) => from(getJobScheduleUnit(data)).pipe(
    map((res: JobScheduleListDataResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getJobScheduleUnitDataSuccess(res.BMT.Result);
      }
      return getJobScheduleUnitDataFailure();
    }),
    takeUntil(action$.pipe(filter(getJobScheduleUnitData.match))),
    catchError((error) => of(getJobScheduleListDataFailure(error))),
  )),
);

async function getJobTravelList(data: JobScheduleListPayload): Promise<JobTravelListDataResponse> {
  const url = `${Config.jobsSchedule.GetHotelListing}?pageNumber=${data.page}&pageSize=${data.rowsPerPage}&searchItem=${data.searchQuery}&BidId=${data?.BidId}`;
  const result = await makeGetRequest<JobTravelListDataResponse>(url);
  return result.data;
}

export const getJobTravelDataEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(getJobTravelListData.type),
  map((x) => x.payload),
  debounceTime(250),
  mergeMap((data: JobScheduleListPayload) => from(getJobTravelList(data)).pipe(
    map((res: JobTravelListDataResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getJobTravelListDataSuccess(res.BMT.Result);
      }
      return getJobTravelListDataFailure();
    }),
    takeUntil(action$.pipe(filter(getJobTravelListData.match))),
    catchError((error) => of(getJobTravelListDataFailure(error))),
  )),
);

async function getOnAddSchedule(data: AddSchedulePayload): Promise<AddScheduleResponse> {
  const url = `${Config.jobsSchedule.CreateJobSchedule}`;
  const result = await makePostRequest<AddScheduleResponse>(url, data);
  return result.data;
}

export const onAddScheduleEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onAddSchedule.type),
  map((x) => x.payload),
  mergeMap((data: AddSchedulePayload) => from(getOnAddSchedule(data)).pipe(
    map((res: AddScheduleResponse) => {
      if (res.BMT.ResponseCode === Config.POST_SUCCESS_CODE) {
        showSuccessToaster(`Job Order ${data?.UnitId} has been created successfully`);
        return onAddScheduleSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return onAddScheduleFailure();
    }),
    takeUntil(action$.pipe(filter(onAddSchedule.match))),
    catchError((error) => of(getJobTravelListDataFailure(error))),
  )),
);

async function getOnUpdateSchedule(data: EditSchedulePayload): Promise<AddScheduleResponse> {
  const url = `${Config.jobsSchedule.UpdateJobSchedule}`;
  const result = await makePutRequest<AddScheduleResponse>(url, data);
  return result.data;
}

export const onUpdateScheduleEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onUpdateSchedule.type),
  map((x) => x.payload),
  mergeMap((data: EditSchedulePayload) => from(getOnUpdateSchedule(data)).pipe(
    map((res: AddScheduleResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        return onAddScheduleSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return onAddScheduleFailure();
    }),
    takeUntil(action$.pipe(filter(onUpdateSchedule.match))),
    catchError((error) => of(getJobTravelListDataFailure(error))),
  )),
);

async function getOnAddAccommodationSchedule(data: AddHotelPayload): Promise<AddScheduleResponse> {
  const url = `${Config.jobsSchedule.HotelAccomodation}`;
  const result = await makePostRequest<AddScheduleResponse>(url, data);
  return result.data;
}

export const onAddAccommodationScheduleEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onAddAccommodationSchedule.type),
  map((x) => x.payload),
  mergeMap((data: AddHotelPayload) => from(getOnAddAccommodationSchedule(data)).pipe(
    map((res: AddScheduleResponse) => {
      if (res.BMT.ResponseCode === Config.POST_SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        return onAddAccommodationScheduleSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return onAddAccommodationScheduleFailure();
    }),
    takeUntil(action$.pipe(filter(onAddAccommodationSchedule.match))),
    catchError((error) => of(onAddAccommodationScheduleFailure(error))),
  )),
);

async function getOnUpdateAccommodationSchedule(data: AddHotelPayload): Promise<AddScheduleResponse> {
  const url = `${Config.jobsSchedule.HotelAccomodation}`;
  const result = await makePostRequest<AddScheduleResponse>(url, data);
  return result.data;
}

export const onUpdateAccommodationScheduleEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onUpdateAccommodationSchedule.type),
  map((x) => x.payload),
  mergeMap((data: AddHotelPayload) => from(getOnUpdateAccommodationSchedule(data)).pipe(
    map((res: AddScheduleResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        return onAddAccommodationScheduleSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return onAddAccommodationScheduleFailure();
    }),
    takeUntil(action$.pipe(filter(onUpdateAccommodationSchedule.match))),
    catchError((error) => of(onAddAccommodationScheduleFailure(error))),
  )),
);

async function getOnDeleteAccommodationSchedule(data: string): Promise<AddScheduleResponse> {
  const url = `${Config.jobsSchedule.DeleteHotelAccomodation}?HotelId=${data}`;
  const result = await makeDeleteRequest<AddScheduleResponse>(url);
  return result.data;
}

export const onDeleteAccommodationScheduleEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onDeleteAccommodationSchedule.type),
  map((x) => x.payload),
  mergeMap((data: string) => from(getOnDeleteAccommodationSchedule(data)).pipe(
    map((res: AddScheduleResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        return onAddAccommodationScheduleSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return onAddAccommodationScheduleFailure();
    }),
    takeUntil(action$.pipe(filter(onDeleteAccommodationSchedule.match))),
    catchError((error) => of(onAddAccommodationScheduleFailure(error))),
  )),
);

async function getHotelListData(data: JobScheduleListPayload): Promise<JobTravelListDataResponse> {
  const url = `${Config.jobsSchedule.GetHotelListing}?pageNumber=${data.page}&pageSize=${data.rowsPerPage}&searchItem=${data.searchQuery}`;
  const result = await makeGetRequest<JobTravelListDataResponse>(url);
  return result.data;
}

export const getHotelListDataEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(getHotelList.type),
  map((x) => x.payload),
  debounceTime(250),
  mergeMap((data: JobScheduleListPayload) => from(getHotelListData(data)).pipe(
    map((res: JobTravelListDataResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return gotHotelList(res.BMT.Result);
      }
      return getJobScheduleListDataFailure();
    }),
    takeUntil(action$.pipe(filter(getHotelList.match))),
    catchError((error) => of(getJobScheduleListDataFailure(error))),
  )),
);

async function getOnCreateJobSchedule(data: PayloadJobForm): Promise<AddJobScheduleWholeResponse> {
  const url = `${Config.jobsSchedule.CreateMainJobScheduling}`;
  const result = await makePostRequest<AddJobScheduleWholeResponse>(url, data);
  return result.data;
}

export const onCreateJobScheduleEpic = (action$: Observable<JobScheduleActions>, _state$: StateObservable<RootState>) => action$.pipe(
  ofType(onCreateJobSchedule.type),
  map((x) => x.payload),
  mergeMap((data: AddJobScheduleWholePayload) => from(getOnCreateJobSchedule(data?.payload)).pipe(
    mergeMap((res: AddJobScheduleWholeResponse) => {
      // const { navigateFromScheduleTab } = state$.value.jobScheduleReducer;
      if (res.BMT.ResponseCode === Config.POST_SUCCESS_CODE || res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        // if (navigateFromScheduleTab) {
        //   data?.navigate(`/${EndPoints.SCHEDULED_JOB}`);
        // } else {
        //   data?.navigate(`/${EndPoints.UNSCHEDULED_JOB}`);
        // }
        return of(onAddScheduleSuccess(), setLoader(false));
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return of(onCreateJobScheduleSuccess(), setLoader(false));
    }),
    takeUntil(action$.pipe(filter(onCreateJobSchedule.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getJobTravelListDataFailure(error), setLoader(false));
    }),
  )),
);

async function getCommentDataList(data: string): Promise<CommentTabDataResponse> {
  const url = `${Config.jobsSchedule.GetInstructions}?BidId=${data}`;
  const result = await makeGetRequest<CommentTabDataResponse>(url);
  return result.data;
}

export const getCommentDataEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(getCommentData.type),
  map((x) => x.payload),
  mergeMap((data: string) => from(getCommentDataList(data)).pipe(
    map((res: CommentTabDataResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return gotCommentData(res.BMT.Result);
      }
      return getJobTravelListDataFailure();
    }),
    takeUntil(action$.pipe(filter(getCommentData.match))),
    catchError((error) => of(getJobTravelListDataFailure(error))),
  )),
);

// Update Site Data
async function getOnUpdateSiteData(data: UpdateSitePayload): Promise<UpdateSiteResponse> {
  const url = `${Config.jobsSchedule.updateSite}`;
  const result = await makePutRequest<UpdateSiteResponse>(url, data);
  return result.data;
}

export const onUpdateSiteDataEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onUpdateSiteData.type),
  map((x) => x.payload),
  mergeMap(({ payload, jobId }: UpdateSitePayloadData) => from(getOnUpdateSiteData(payload)).pipe(
    mergeMap((res: UpdateSiteResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        if (String(res.BMT.Result)?.trim()?.length > 0) {
          return of(onUpdateSiteDateSuccess(true), setLoader(false), updateSite({ jobId }));
        }
        return of(onUpdateSiteDateSuccess(true), setLoader(false));
        // return of(setSelectedTab(2), onUpdateSiteDateSuccess(true));
      }
      return of(onUpdateSiteDateFailure(true), setLoader(false));
      // return of(onUpdateSiteDateFailure(true), setSelectedTab(2));
    }),
    takeUntil(action$.pipe(filter(onUpdateSiteData.match))),
    catchError((error: AxiosError<UpdateSiteResponse>) => {
      const errorMessage = error?.response?.data?.BMT?.ResponseMessage as string;
      of(showErrorToaster(errorMessage));
      return of(onUpdateSiteDateFailure(!!error), setLoader(false));
    }),
  )),
);

async function getTravelDataByIdList(data: string): Promise<TravelDataById> {
  const url = `${Config.jobsSchedule.JobSchedulingDetailsByBidId}?BidId=${data}`;
  const result = await makeGetRequest<TravelDataById>(url);
  return result.data;
}

export const getTravelDataByIdListEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(getTravelDataById.type),
  map((x) => x.payload),
  debounceTime(250),
  mergeMap((data: string) => from(getTravelDataByIdList(data)).pipe(
    map((res: TravelDataById) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return gotTravelDataById(res.BMT.Result);
      }
      return travelDataByIdFailure(TravelDefaultData as Empty);
    }),
    takeUntil(action$.pipe(filter(getTravelDataById.match))),
    catchError((error) => of(getJobTravelListDataFailure(error))),
  )),
);

async function onReadyToSendStartApiCall(checkedReadyToSend: CheckedReadyToSendInterface): Promise<ReadyToSendStartAPiResponse> {
  const url = Config.jobsSchedule.JobSchedulingReadyToSend;
  const result = await makePutRequest<ReadyToSendStartAPiResponse>(url, checkedReadyToSend);
  return result.data;
}

export const onReadyToSendStartListEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(onReadyToSendStart.type),
  map((x) => x.payload),
  mergeMap((checkedReadyToSend: CheckedReadyToSendInterface) => from(onReadyToSendStartApiCall(checkedReadyToSend)).pipe(
    map((res: ReadyToSendStartAPiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return onReadyToSendSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return onReadyToSendFailure();
    }),
    takeUntil(action$.pipe(filter(onReadyToSendStart.match))),
    catchError((error) => {
      const errorMessage = error?.response?.data?.BMT?.ResponseMessage as string;
      of(showErrorToaster(errorMessage));
      return of(onReadyToSendFailure());
    }),
  )),
);

function AssociatedVesselsListUrl(payload: GetAssociatedVesselsPayload): string {
  let url = `${Config.jobsSchedule.GetReportVesselsUrl}GetAssociatedVessels?joborder=${payload.jobOrderId}&pageNumber=${payload.page}&pageSize=${payload.rowsPerPage}&searchItem=${payload.searchQuery}&type=${payload.type}`;
  if (payload?.VesselId) {
    url = `${url}&VesselId=${payload.VesselId}`;
  }
  return url;
}

// Associated Vessels Listing Epic
export const getAssociatedVesselsEpic = createFetchDataEpic<VesselsListingDetails, GetAssociatedVesselsPayload>(
  getAssociatedVesselsStart.type,
  AssociatedVesselsListUrl,
  getAssociatedVesselsSuccess,
  getAssociatedVesselsFailure,
);

export const getGeneralVesselsEpic = createGetEpicWithData<AllVesselsListingDetails[], GetGeneralVesselsPayload>(
  getGeneralVesselsStart.type,
  (data) => getData<AllVesselsListingDetails[]>(`${Config.jobsSchedule.GetReportVesselsUrl}GetVesselList?joborder=${data.jobOrderId}`),
  getGeneralVesselsSuccess,
  getGeneralVesselsFailure,
);

async function AddJobReport(data: AddReportPayload[]): Promise<AddScheduleResponse> {
  const url = `${Config.jobsSchedule.AddReportVesselsUrl}Retest`;
  const payload = {
    RetestRequestList: data,
  };
  // if (IsReportPresent) {
  //   const result = await makePutRequest<AddScheduleResponse>(url, payload);
  //   return result.data;
  // }
  const result = await makePostRequest<AddScheduleResponse>(url, payload);
  return result.data;
}

// export const AddJobReportEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
//   ofType(addJobReport.type),
//   map((x) => x.payload),
//   mergeMap(({
//     payloads, setOpenFrom, callback,
//   }) => from(AddJobReport(payloads)).pipe(
//     map((res: AddScheduleResponse) => {
//       if (res.BMT.ResponseCode === Config.POST_SUCCESS_CODE) {
//         showSuccessToaster(res.BMT.ResponseMessage);
//         if (setOpenFrom) {
//           setOpenFrom(false);
//         }
//         if (callback) {
//           callback();
//         }
//         const payload = {
//           jobOrderId: payloads.UnitId,
//         };
//         return of(addJobReportSuccess(), getGeneralVesselsStart(payload), getReportByIdStart(payload));
//       }
//       showErrorToaster(res.BMT.ResponseMessage);
//       return addJobReportFailure();
//     }),
//     takeUntil(action$.pipe(filter(addJobReport.match))),
//     catchError((error: AxiosError<AddScheduleResponse>) => {
//       const errorMessage = error?.response?.data?.BMT?.ResponseStatus as string;
//       of(showErrorToaster(errorMessage));
//       return of(addJobReportFailure());
//     }),
//   )),
// );

export const AddJobReportEpic = (action$: Observable<JobScheduleActions>) => action$.pipe(
  ofType(addJobReport.type),
  map((x) => x.payload),
  mergeMap(({ payloads, setOpenFrom, callback }) => from(AddJobReport(payloads)).pipe(
    mergeMap((res: AddScheduleResponse) => {
      if (res.BMT.ResponseCode === Config.POST_SUCCESS_CODE) {
        showSuccessToaster(res.BMT.ResponseMessage);
        if (callback) {
          callback();
        }
        const payload = {
          jobOrderId: payloads[0].UnitId,
        };

        if (setOpenFrom) {
          setTimeout(() => setOpenFrom(false), 2000);
        }

        return [
          addJobReportSuccess(),
          getGeneralVesselsStart(payload),
          getReportByIdStart(payload),
        ];
      }

      showErrorToaster(res.BMT.ResponseMessage);
      return of(addJobReportFailure());
    }),
    takeUntil(action$.pipe(filter(addJobReport.match))),
    catchError((error: AxiosError<AddScheduleResponse>) => {
      const errorMessage = error?.response?.data?.BMT?.ResponseStatus || 'An error occurred';
      showErrorToaster(errorMessage);
      return of(addJobReportFailure());
    }),
  )),
);

// Get Report by ID
export const getReportDataByIdEpic = createGetEpicWithData<SetVesselData[], GetGeneralVesselsPayload>(
  getReportByIdStart.type,
  (data) => getData<SetVesselData[]>(`${Config.jobsSchedule.AddReportVesselsUrl}Retest?jobOrder=${data.jobOrderId}`),
  getReportByIdSuccess,
  getReportByIdFailure,
);

// Delete Contact
async function deleteVesselReport(data: DeleteVesselReportPayload): Promise<DeleteReportApiResponse> {
  const url = `${Config.jobsSchedule.DeleteReportVesselsUrl}?retestId=${data.payload.id}`;
  const result = await makeDeleteRequest<DeleteReportApiResponse>(url);
  return result.data;
}

export const deleteVesselReportsEpic = (action$ : Observable<JobScheduleActions>) => action$.pipe(
  ofType(deleteReportByIdStart.type),
  map((x) => x.payload),
  mergeMap((data: DeleteVesselReportPayload) => from(deleteVesselReport(data)).pipe(
    mergeMap((res: DeleteReportApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        const payload = {
          jobOrderId: data.jobOrderId,
        };
        if (data.callback) {
          data.callback();
        }
        if (data.setValue) {
          data.setValue(data.payload.vesselId, '');
        }
        showSuccessToaster(res.BMT.ResponseMessage);
        return of(deleteReportByIdSuccess(), getReportByIdStart(payload));
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return of(deleteReportByIdFailure());
    }),
    takeUntil(action$.pipe(filter(deleteReportByIdStart.match))),
    catchError((error) => of(deleteReportByIdFailure(error))),
  )),
);

async function removeScheduleAPI(data: DeleteSchedulePayload): Promise<DeleteReportApiResponse> {
  const url = `${Config.jobsSchedule.RemoveScheduleUrl}?UnitId=${data.id}`;
  const result = await makeGetRequest<DeleteReportApiResponse>(url);
  return result.data;
}

export const removeScheduleEpic = (action$ : Observable<JobScheduleActions>) => action$.pipe(
  ofType(deleteScheduleByIdStart.type),
  map((x) => x.payload),
  mergeMap((data: DeleteSchedulePayload) => from(removeScheduleAPI(data)).pipe(
    mergeMap((res: DeleteReportApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        if (data.isScheduleJob === true) {
          data.navigate(-1);
        } else {
          data.callback();
          data.closeModal();
        }
        showSuccessToaster(res.BMT.ResponseMessage);
        return of(deleteScheduleByIdSuccess());
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return of(deleteScheduleByIdFailure());
    }),
    takeUntil(action$.pipe(filter(deleteScheduleByIdStart.match))),
    catchError((error) => of(deleteScheduleByIdFailure(error))),
  )),
);

async function getSchedulePdfDataAPI(data: { JobOrders: string[] }): Promise<GetSchedulePdfDataApiResponse> {
  const url = Config.jobsSchedule.GetSchedulingPdf;
  const result = await makePostRequest<GetSchedulePdfDataApiResponse>(url, data);
  return result.data;
}

export const getSchedulePdfDataEpic = (action$ : Observable<JobScheduleActions>) => action$.pipe(
  ofType(getSchedulingPdfData.type),
  map((x) => x.payload),
  mergeMap((data: { JobOrders: string[] }) => from(getSchedulePdfDataAPI(data)).pipe(
    mergeMap((res: GetSchedulePdfDataApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return of(getSchedulingPdfDataSuccess(res.BMT.Result));
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return of(getSchedulingPdfDataFailure());
    }),
    takeUntil(action$.pipe(filter(getSchedulingPdfData.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getSchedulingPdfDataFailure());
    }),
  )),
);
async function getForecastReportAPI(data: object): Promise<GetForecastDataApiResponse> {
  const url = Config.jobsSchedule.GetForecastReport;
  const result = await makeGetRequestWithParams<GetForecastDataApiResponse>(url, data);
  return result.data;
}

export const getForecastReportEpic = (action$ : Observable<JobScheduleActions>) => action$.pipe(
  ofType(getForecastReport.type),
  map((x) => x.payload),
  mergeMap((data: object) => from(getForecastReportAPI(data)).pipe(
    mergeMap((res: GetForecastDataApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return of(getForecastReportSuccess(res.BMT.Result));
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return of(getForecastReportFailure());
    }),
    takeUntil(action$.pipe(filter(getForecastReport.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getForecastReportFailure());
    }),
  )),
);
